<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Mechanical Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        <div class="halfWidthConfigurationInput">
          @if (returnAirLocationSelection) {
            <div class="modConnectionRow">
              <label class="modConnectionLabel">Return Location:</label>
              <select class="modConnectionField" #returnLocationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnAirLocationSelection.Name)"
                (change)="selectionChanged(returnAirLocationSelection, returnLocationInput.value)"
                [value]="returnAirLocationSelection.Value.toString()">
                @for (allowable of returnAirLocationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnAirLocationSelection.Value && returnAirLocationSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (universalSupplySelection) {
            <div class="modConnectionRow">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(universalSupplySelection.Name)"
              for="universalSupplyInput" class="halfWidthInputLabel">Universal Supply:</label>
              <input type="checkbox" class="checkboxInput" id="universalSupplyInput"
                #universalSupplyInput [checked]="'true' === universalSupplySelection.Value"
                (change)="selectionChanged(universalSupplySelection, universalSupplyInput.checked.toString())">
            </div>
          }
          @if (frontSupplySelection) {
            <div class="modConnectionRow">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(frontSupplySelection.Name)"
              for="frontSupplyInput" class="modConnectionLabel">Front Supply:</label>
              <input type="checkbox" class="checkboxInput" id="frontSupplyInput"
                #frontSupplyInput [checked]="'true' === frontSupplySelection.Value"
                (change)="selectionChanged(frontSupplySelection, frontSupplyInput.checked.toString())">
              @if (topSupplySelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(topSupplySelection.Name)"
                  for="topSupplyInput" class="modConnectionCheckboxLabel">Top Supply:</label>
                  <input type="checkbox" class="checkboxInput" id="topSupplyInput"
                    #topSupplyInput [checked]="'true' === topSupplySelection.Value"
                    (change)="selectionChanged(topSupplySelection, topSupplyInput.checked.toString())">
                </span>
              }
            </div>
          }
          @if (leftSupplySelection) {
            <div class="modConnectionRow">
              <label [class.invalidConfigurationSelection]="isInvalidSelection(leftSupplySelection.Name)"
              for="leftSupplyInput" class="halfWidthInputLabel">Left Supply:</label>
              <input type="checkbox" class="checkboxInput" id="leftSupplyInput"
                #leftSupplyInput [checked]="'true' === leftSupplySelection.Value"
                (change)="selectionChanged(leftSupplySelection, leftSupplyInput.checked.toString())">
              @if (rightSupplySelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(rightSupplySelection.Name)"
                  for="rightSupplyInput" class="modConnectionCheckboxLabel">Right Supply:</label>
                  <input type="checkbox" class="checkboxInput" id="rightSupplyInput"
                    #rightSupplyInput [checked]="'true' === rightSupplySelection.Value"
                    (change)="selectionChanged(rightSupplySelection, rightSupplyInput.checked.toString())">
                </span>
              }
            </div>
          }
          @if (riserConnectionSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Riser Connection:</label>
              <select class="halfWidthInputField" #riserConnectionInput
                [class.invalidConfigurationSelection]="isInvalidSelection(riserConnectionSelection.Name)"
                (change)="selectionChanged(riserConnectionSelection, riserConnectionInput.value)"
                [value]="riserConnectionSelection.Value.toString()">
                @for (allowable of riserConnectionSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="riserConnectionSelection.Value && riserConnectionSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (returnAirStyleSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Return Air Style:</label>
              <select class="halfWidthInputField" #returnStyleInput
                [class.invalidConfigurationSelection]="isInvalidSelection(returnAirStyleSelection.Name)"
                (change)="selectionChanged(returnAirStyleSelection, returnStyleInput.value)"
                [value]="returnAirStyleSelection.Value.toString()">
                @for (allowable of returnAirStyleSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="returnAirStyleSelection.Value && returnAirStyleSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (supplyTypeSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Supply Air Type:</label>
              <select class="halfWidthInputField" #supplyTypeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(supplyTypeSelection.Name)"
                (change)="selectionChanged(supplyTypeSelection, supplyTypeInput.value)"
                [value]="supplyTypeSelection.Value.toString()">
                @for (allowable of supplyTypeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="supplyTypeSelection.Value && supplyTypeSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (opposedBladeDamperSelection || sightBaffleSelection) {
            <div class="modConnectionRow">
              @if (opposedBladeDamperSelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(opposedBladeDamperSelection.Name)"
                  for="opposedBladeDamperInput" class="halfWidthInputLabel">Opposed Blade Damper:</label>
                  <input type="checkbox" class="checkboxInput" id="opposedBladeDamperInput"
                    #opposedBladeDamperInput [checked]="'true' === opposedBladeDamperSelection.Value"
                    (change)="selectionChanged(opposedBladeDamperSelection, opposedBladeDamperInput.checked.toString())">
                </span>
              }
              @if (sightBaffleSelection) {
                <span>
                  <label [class.invalidConfigurationSelection]="isInvalidSelection(sightBaffleSelection.Name)"
                  for="sightBaffleInput" class="modConnectionCheckboxLabel">Sight Baffle:</label>
                  <input type="checkbox" class="checkboxInput" id="sightBaffleInput"
                    #sightBaffleInput [checked]="'true' === sightBaffleSelection.Value"
                    (change)="selectionChanged(sightBaffleSelection, sightBaffleInput.checked.toString())">
                </span>
              }
            </div>
          }
          @if (outsideAirSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Outside Air:</label>
              <select class="halfWidthInputField" #outsideAirInput
                [class.invalidConfigurationSelection]="isInvalidSelection(outsideAirSelection.Name)"
                (change)="selectionChanged(outsideAirSelection, outsideAirInput.value)"
                [value]="outsideAirSelection.Value.toString()">
                @for (allowable of outsideAirSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="outsideAirSelection.Value && outsideAirSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (outsideAirLocationSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Outside Air Location:</label>
              <select class="halfWidthInputField" #outsideAirLocationInput
                [class.invalidConfigurationSelection]="isInvalidSelection(outsideAirLocationSelection.Name)"
                (change)="selectionChanged(outsideAirLocationSelection, outsideAirLocationInput.value)"
                [value]="outsideAirLocationSelection.Value.toString()">
                @for (allowable of outsideAirLocationSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="outsideAirLocationSelection.Value && outsideAirLocationSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
          @if (paintOptionsSelection) {
            <div class="modConnectionRow">
              <label class="halfWidthInputLabel">Paint Options:</label>
              <select class="halfWidthInputField" #paintOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(paintOptionsSelection.Name)"
                (change)="selectionChanged(paintOptionsSelection, paintOptionsInput.value)"
                [value]="paintOptionsSelection.Value.toString()">
                @for (allowable of paintOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="paintOptionsSelection.Value && paintOptionsSelection.Value.toString() === allowable.Value"
                    [value]="allowable.Value">{{ allowable.Description }}
                  </option>
                }
              </select>
            </div>
          }
        </div>
        <div class="halfWidthConfigurationInput">
          @if (pipeDetailImagePath() && pipeDetailImagePath().length > 0) {
            <img class="detailImage"
              [src]="pipeDetailImagePath()" alt="PipeDetailImage"/>
          }
          @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
            <img class="detailImage"
              [src]="handArrangementImagePath()" alt="ArrangementImage"/>
          }
        </div>
      </div>
    </div>
  }
</div>
